import React from "react";
import ReactDOM from "react-dom/client"
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Helmet } from "react-helmet";

import "./styles/index.css"

import Home from "./pages/Home";
import Birthday from "./pages/Birthday";
import Networks from "./pages/Networks";

import BirthdayJoin from "./pages/BirthdayParty/BirthdayJoin";
import BirthdayAdmin from "./pages/BirthdayParty/BirthdayAdmin";
import BirthdayScreen from "./pages/BirthdayParty/BirthdayScreen";

import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <BrowserRouter>
        <Routes>

            <Route path="*" element={
                <>
                <Helmet>
                    <title>Kenzo Simon</title>
                    <meta name='description' 
                        content="Portfolio de Kenzo Simon Tintinaglia"
                    />

                    <meta name='robots' content='index,follow' />
                    {/* <link rel='canonical' href={`${pagesData["others"].url}`} /> */}
                    <meta name="subject" content="Portfolio de Kenzo Simon Tintinaglia" />

                    <meta property='og:title' content="Kenzo Simon" />
                    <meta property='og:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                    <meta property='og:type' content='website' />
                    {/* <meta property='og:image' content={`${pagesData["others"].banner}`} /> */}
                    {/* <meta property='og:url' content={`${pagesData["others"].url}`} /> */}

                    <meta name='twitter:card' content='summary_large_image' />
                    <meta name='twitter:tittle' content="Kenzo Simon" />
                    <meta name='twitter:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                    {/* <meta name='twitter:image' content={`${pagesData["others"].banner}`} /> */}

                    <meta name="keywords" content="développement web, web, création de sites internet, Kédysa Studios, Kédysa, Kenzo, blog, Kenzo Simon, Kenzo Simon Tintinaglia, Tintinaglia, développeur" />
                </Helmet>

                <Home />
                </>
            } />

            <Route exact path="birthday" element={
                <>
                <Helmet>
                    <title>Kenzo fête ses 20 ans</title>
                    <meta name='description' 
                        content="Portfolio de Kenzo Simon Tintinaglia"
                    />

                    <meta name='robots' content='noindex,nofollow' />
                    {/* <link rel='canonical' href={`${pagesData["others"].url}`} /> */}
                    <meta name="subject" content="Portfolio de Kenzo Simon Tintinaglia" />

                    <meta property='og:title' content="Kenzo Simon" />
                    <meta property='og:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                    <meta property='og:type' content='website' />
                    {/* <meta property='og:image' content={`${pagesData["others"].banner}`} /> */}
                    {/* <meta property='og:url' content={`${pagesData["others"].url}`} /> */}

                    <meta name='twitter:card' content='summary_large_image' />
                    <meta name='twitter:tittle' content="Kenzo Simon" />
                    <meta name='twitter:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                    {/* <meta name='twitter:image' content={`${pagesData["others"].banner}`} /> */}

                    <meta name="keywords" content="développement web, web, création de sites internet, Kédysa Studios, Kédysa, Kenzo, blog, Kenzo Simon, Kenzo Simon Tintinaglia, Tintinaglia, développeur" />
                </Helmet>

                <Birthday />
                </>
            } />

            <Route exact path="networks" element={
                <>
                <Helmet>
                    <title>Kenzo Simon - Réseaux sociaux</title>
                    <meta name='description' 
                        content="Réseaux sociaux de Kenzo Simon Tintinaglia"
                    />
                    
                    <meta name='robots' content='index,follow' />
                    <link rel='canonical' href={`https://www.kenzo-simon.fr/networks`} />
                    <meta name="subject" content="Réseaux sociaux de Kenzo Simon Tintinaglia" />

                    <meta property='og:title' content="Kenzo Simon" />
                    <meta property='og:description' content="Réseaux sociaux de Kenzo Simon Tintinaglia" />
                    <meta property='og:type' content='website' />
                    {/* <meta property='og:image' content={`${pagesData["others"].banner}`} /> */}
                    <meta property='og:url' content={"https://www.kenzo-simon.fr/networks"} />

                    <meta name='twitter:card' content='summary_large_image' />
                    <meta name='twitter:tittle' content="Kenzo Simon" />
                    <meta name='twitter:description' content="Réseaux sociaux de Kenzo Simon Tintinaglia" />
                    {/* <meta name='twitter:image' content={`${pagesData["others"].banner}`} /> */}

                    <meta name="keywords" content="développement web, web, création de sites internet, Kédysa Studios, Kédysa, Kenzo, blog, Kenzo Simon, Kenzo Simon Tintinaglia, Tintinaglia, développeur, réseaux sociaux, social networks, networks, réseau" />
                </Helmet>

                <Networks />
                </>
            } 
            />

            <Route exact path="birthday/join" element={
                <>
                <Helmet>
                    <title>Kenzo fête ses 20 ans</title>
                    <meta name='description' 
                        content="Portfolio de Kenzo Simon Tintinaglia"
                    />

                    <meta name='robots' content='noindex,nofollow' />
                    <meta name="subject" content="Portfolio de Kenzo Simon Tintinaglia" />

                    <meta property='og:title' content="Kenzo Simon" />
                    <meta property='og:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                    <meta property='og:type' content='website' />

                    <meta name='twitter:card' content='summary_large_image' />
                    <meta name='twitter:tittle' content="Kenzo Simon" />
                    <meta name='twitter:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                </Helmet>

                <BirthdayJoin />
                </>
            } />

            <Route exact path="birthday/admin" element={
                <>
                <Helmet>
                    <title>Kenzo - Admin</title>
                    <meta name='description' 
                        content="Portfolio de Kenzo Simon Tintinaglia"
                    />

                    <meta name='robots' content='noindex,nofollow' />
                    <meta name="subject" content="Portfolio de Kenzo Simon Tintinaglia" />

                    <meta property='og:title' content="Kenzo Simon" />
                    <meta property='og:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                    <meta property='og:type' content='website' />

                    <meta name='twitter:card' content='summary_large_image' />
                    <meta name='twitter:tittle' content="Kenzo Simon" />
                    <meta name='twitter:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                </Helmet>

                <BirthdayAdmin />
                </>
            } />

            <Route exact path="birthday/screen" element={
                <>
                <Helmet>
                    <title>Kenzo fête ses 20 ans</title>
                    <meta name='description' 
                        content="Portfolio de Kenzo Simon Tintinaglia"
                    />

                    <meta name='robots' content='noindex,nofollow' />
                    <meta name="subject" content="Portfolio de Kenzo Simon Tintinaglia" />

                    <meta property='og:title' content="Kenzo Simon" />
                    <meta property='og:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                    <meta property='og:type' content='website' />

                    <meta name='twitter:card' content='summary_large_image' />
                    <meta name='twitter:tittle' content="Kenzo Simon" />
                    <meta name='twitter:description' content="Portfolio de Kenzo Simon Tintinaglia" />
                </Helmet>

                <BirthdayScreen />
                </>
            } />

        </Routes>
    </BrowserRouter>
)

reportWebVitals();